<template>
  <div class="Page">
    페이지예시
  </div>
</template>

<script>
export default {
  name: "ReportList",
  data() {
    return {
      subMenuGroups: [
        {
          title: "프로젝트 그룹 1",
          open: true,
          projects: ["프로젝트명 A", "프로젝트명 B", "프로젝트명 C"],
        },
        {
          title: "프로젝트 그룹 2",
          open: true,
          projects: ["프로젝트명 D", "프로젝트명 E"],
        },
      ],
    };
  },
  methods: {
    toggleGroup(index) {
      this.subMenuGroups[index].open = !this.subMenuGroups[index].open;
    },
  },
};
</script>

